module.exports = "/images/ny-life2-2.jpg";